import React from "react";
import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Chip,
    Divider,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LinkIcon from "@mui/icons-material/Link";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CasinoIcon from "@mui/icons-material/Casino";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { FaPatreon, FaYoutube, FaTwitch } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import { showSuccessToast } from "../Visuals/ToastNotification";

import music from "./img/music.jpg";
import video from "./img/video.jpg";
import drum from "./img/drum.jpg";
import ayk from "./img/ayk.jpg";
import ayk2 from "./img/ayk2.jpg";
import mega from "./img/mega.jpg";
import two from "./img/two.jpg";

const REWARDS = [
    {
        id: "music",
        title: "Музичку",
        price: 500,
        description:
            "Маєш можливість замовити любу свою музику за 500 шизобалів. Пиши в чат! Команда: !хочу музику",
        command: "!хочу музику",
        img: music,
    },
    {
        id: "video",
        title: "Перегляд відосу",
        price: 1000,
        description: "Замовити відос до 5хв на стрімі. Команда: !хочу відос",
        command: "!хочу відос",
        img: video,
    },
    {
        id: "ayks",
        title: "Команда для колізея",
        price: 100,
        description:
            "Команда дозволяє вам кинути 50грн на участь в битвах колізея для себе або когось іншого не гривнями, а ШИЗОБАЛАМИ",
        command: "!хочу колізей100",
        img: ayk,
    },
    {
        id: "ayks2",
        title: "Команда для колізея Х10",
        price: 1000,
        description:
            "Команда дозволяє вам кинути 500грн на участь в битвах колізея для себе або когось іншого не гривнями, а ШИЗОБАЛАМИ",
        command: "!хочу колізей1000",
        img: drum,
    },
    {
        id: "mega",
        title: "Команда для колізея Х100",
        price: 10000,
        description:
            "Команда дозволяє вам кинути 5000грн на участь в битвах колізея для себе або когось іншого не гривнями, а ШИЗОБАЛАМИ",
        command: "!хочу колізей10000",
        img: mega,
    },
    {
        id: "two",
        title: "Команда для колізея Х1000",
        price: 100000,
        description:
            "Команда дозволяє вам кинути 50000грн на участь в битвах колізея для себе або когось іншого не гривнями, а ШИЗОБАЛАМИ",
        command: "!хочу колізей100000",
        img: two,
    },
    {
        id: "drum",
        title: "Барабан",
        price: 3000,
        description:
            "Замовляй барабан ціною в 300 грн за 3000 шизобалів. Команда: !хочу барабан",
        command: "!хочу барабан",
        img: ayk2,
    }
];

const FUN_COMMANDS = [
    {
        id: "give",
        title: "Передати шизобали іншій людині",
        command: "!дати нік кількість",
        access: "Всі",
        description:
            "Дає можливість передати шизобали іншій людині. Зручно для подарунків або підтримки.",
        usage: "!дати VerumT 250",
        icon: <SwapHorizIcon fontSize="small" />,
    },
    {
        id: "8ball",
        title: "Магічна куля відповідає на питання",
        command: "!8ball питання",
        access: "Всі",
        description: "Пиши команду, далі своє питання — і магічна куля видасть відповідь.",
        usage: "!8ball світло нині буде?",
        icon: <CasinoIcon fontSize="small" />,
    },
];

async function copyCommand(text) {
    try {
        await navigator.clipboard.writeText(text);
        showSuccessToast("Команда скопійована!");
    } catch {
        try {
            const ta = document.createElement("textarea");
            ta.value = text;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            document.body.removeChild(ta);
            showSuccessToast("Команда скопійована!");
        } catch {
            showSuccessToast("Не вдалося скопіювати :(");
        }
    }
}

const panelSx = {
    p: 2,
    borderRadius: 3,
    background: "rgba(10, 14, 28, 0.45)",
    border: "1px solid rgba(255,255,255,0.10)",
    backdropFilter: "blur(10px)",
};

const Shizobali = () => {
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: 1250,
                mx: "auto",
                px: { xs: 2, md: 3 },
                py: { xs: 3, md: 4 },
            }}
        >
            <ToastContainer />

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", lg: "1.6fr 1fr" },
                    gap: 2.2,
                    alignItems: "start",
                }}
            >
                <Paper sx={{ ...panelSx, order: { xs: 2, lg: 1 } }}>
                    <Typography sx={{ color: "#fff", fontWeight: 900, mb: 1.5 }}>
                        <h2 style={{ margin: 0 }}>Магазин шизобалів:</h2>
                    </Typography>

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                            gap: 2,
                        }}
                    >
                        {REWARDS.map((r) => (
                            <Card
                                key={r.id}
                                sx={{
                                    borderRadius: 3,
                                    overflow: "hidden",
                                    background: "rgba(12, 16, 32, 0.65)",
                                    border: "1px solid rgba(255,255,255,0.10)",
                                    boxShadow: "0 16px 30px rgba(0,0,0,0.35)",
                                    transition: "transform 160ms ease, filter 160ms ease",
                                    "&:hover": { transform: "scale(1.01)", filter: "brightness(1.05)" },
                                }}
                            >
                                <CardMedia
                                    component="div"
                                    sx={{
                                        height: 140,
                                        background:
                                            r.img && String(r.img).trim()
                                                ? `url(${r.img}) center/cover no-repeat`
                                                : "linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.02))",
                                    }}
                                />

                                <CardContent sx={{ p: 2 }}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: 1,
                                            mb: 1,
                                        }}
                                    >
                                        <Typography sx={{ color: "#fff", fontWeight: 900 }}>{r.title}</Typography>

                                        <Chip
                                            label={`${r.price} Points`}
                                            size="small"
                                            sx={{
                                                background: "rgba(255,255,255,0.12)",
                                                color: "rgba(255,255,255,0.9)",
                                                fontWeight: 800,
                                            }}
                                        />
                                    </Box>

                                    <Typography
                                        variant="body2"
                                        sx={{ color: "rgba(255,255,255,0.72)", minHeight: 64 }}
                                    >
                                        {r.description}
                                    </Typography>

                                    <Box sx={{ mt: 1.5, display: "flex", justifyContent: "center" }}>
                                        <Button
                                            variant="contained"
                                            onClick={() => copyCommand(r.command)}
                                            sx={{
                                                borderRadius: 999,
                                                textTransform: "none",
                                                fontWeight: 900,
                                                px: 2.2,
                                                py: 0.9,
                                                background:
                                                    "linear-gradient(90deg, rgba(56,132,246,0.85), rgba(255,122,148,0.70))",
                                                "&:hover": { transform: "translateY(-1px)" },
                                                transition: "all 160ms ease",
                                            }}
                                        >
                                            {r.command}
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                </Paper>

                <Box
                    sx={{
                        order: { xs: 1, lg: 2 },
                        display: "flex",
                        flexDirection: "column",
                        gap: 2.2,
                        minWidth: 0,
                    }}
                >
                    <Paper sx={panelSx}>
                        <Typography sx={{ color: "#fff", fontWeight: 900, mb: 0.5 }}>
                            Донатний потенціал
                        </Typography>
                        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.65)", mb: 1.5 }}>
                            Якщо хочеш підтримати автора — ось варіанти:
                        </Typography>

                        <Stack spacing={1.3}>
                            <Button
                                variant="contained"
                                href="https://www.patreon.com/verumT?fan_landing=true"
                                target="_blank"
                                rel="noopener noreferrer"
                                startIcon={<FaPatreon />}
                                sx={{
                                    borderRadius: 999,
                                    textTransform: "none",
                                    fontWeight: 900,
                                    px: 2.5,
                                    py: 1.1,
                                    background: "linear-gradient(90deg, #ff424d, #ff6b6b)",
                                    "&:hover": {
                                        background: "linear-gradient(90deg, #ff5a63, #ff8787)",
                                        transform: "translateY(-1px)",
                                    },
                                    transition: "all 160ms ease",
                                }}
                            >
                                Patreon — Підтримка автора
                            </Button>

                            <Button
                                variant="contained"
                                href="http://buymeacoffee.com/VerumT"
                                target="_blank"
                                rel="noopener noreferrer"
                                startIcon={<AttachMoneyIcon />}
                                sx={{
                                    borderRadius: 999,
                                    textTransform: "none",
                                    fontWeight: 900,
                                    px: 2.5,
                                    py: 1.1,
                                    background: "linear-gradient(90deg, #fbbf24, #f59e0b)",
                                    color: "#111827",
                                    "&:hover": {
                                        background: "linear-gradient(90deg, #fcd34d, #f59e0b)",
                                        transform: "translateY(-1px)",
                                    },
                                    transition: "all 160ms ease",
                                }}
                            >
                                Buy Me a Coffee — донат у доларах
                            </Button>

                            <Button
                                variant="contained"
                                href="https://www.youtube.com/@verum_t"
                                target="_blank"
                                rel="noopener noreferrer"
                                startIcon={<FaYoutube />}
                                sx={{
                                    borderRadius: 999,
                                    textTransform: "none",
                                    fontWeight: 900,
                                    px: 2.5,
                                    py: 1.1,
                                    background: "linear-gradient(90deg, #b91c1c, #ef4444)",
                                    "&:hover": {
                                        background: "linear-gradient(90deg, #dc2626, #f87171)",
                                        transform: "translateY(-1px)",
                                    },
                                    transition: "all 160ms ease",
                                }}
                            >
                                YouTube — Платні підписки
                            </Button>

                            <Button
                                variant="contained"
                                href="https://www.twitch.tv/verumt"
                                target="_blank"
                                rel="noopener noreferrer"
                                startIcon={<FaTwitch />}
                                sx={{
                                    borderRadius: 999,
                                    textTransform: "none",
                                    fontWeight: 900,
                                    px: 2.5,
                                    py: 1.1,
                                    background: "linear-gradient(90deg, #6d28d9, #8b5cf6)",
                                    "&:hover": {
                                        background: "linear-gradient(90deg, #7c3aed, #a78bfa)",
                                        transform: "translateY(-1px)",
                                    },
                                    transition: "all 160ms ease",
                                }}
                            >
                                Twitch — Платні підписки
                            </Button>
                        </Stack>

                    </Paper>

                    <Paper
                        sx={{
                            ...panelSx,
                            order: { xs: 3, lg: 2 },
                            background: "linear-gradient(135deg, rgba(8,12,28,0.60), rgba(10,22,55,0.42))",
                            border: "1px solid rgba(255,255,255,0.10)",
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                            <Typography sx={{ color: "#fff", fontWeight: 900 }}>
                                Цікаві команди
                            </Typography>

                            <Chip
                                label="чат-команди"
                                size="small"
                                sx={{
                                    background: "rgba(255,255,255,0.10)",
                                    color: "rgba(255,255,255,0.85)",
                                    fontWeight: 900,
                                    border: "1px solid rgba(255,255,255,0.10)",
                                }}
                            />
                        </Box>

                        <Divider sx={{ my: 1.5, borderColor: "rgba(255,255,255,0.10)" }} />

                        <Stack spacing={1.15}>
                            {FUN_COMMANDS.map((c) => {
                                const isMod = c.access === "Модератори";

                                const rowBg = isMod
                                    ? "linear-gradient(135deg, rgba(30,58,138,0.26), rgba(15,23,42,0.30))" // темно-синій
                                    : "linear-gradient(135deg, rgba(16,185,129,0.18), rgba(15,23,42,0.30))"; // зелений

                                const rowBorder = isMod ? "rgba(59,130,246,0.22)" : "rgba(16,185,129,0.22)";

                                const rail = isMod
                                    ? "linear-gradient(180deg, rgba(59,130,246,0.90), rgba(37,99,235,0.30))"
                                    : "linear-gradient(180deg, rgba(16,185,129,0.90), rgba(5,150,105,0.30))";

                                return (
                                    <Paper
                                        key={c.id}
                                        elevation={0}
                                        sx={{
                                            position: "relative",
                                            p: 1.45,
                                            borderRadius: 2.6,
                                            border: `1px solid ${rowBorder}`,
                                            background: rowBg,
                                            overflow: "hidden",

                                            boxShadow: "0 10px 24px rgba(0,0,0,0.35)",
                                            transition: "transform 160ms ease, filter 160ms ease, border-color 160ms ease",

                                            "&:hover": {
                                                transform: "translateY(-1px)",
                                                filter: "brightness(1.06)",
                                                borderColor: isMod ? "rgba(59,130,246,0.35)" : "rgba(16,185,129,0.35)",
                                            },

                                            "&:before": {
                                                content: '""',
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                bottom: 0,
                                                width: 5,
                                                background: rail,
                                                opacity: 0.9,
                                            },
                                        }}
                                    >
                                        <Box sx={{ display: "flex", gap: 1.2, alignItems: "flex-start" }}>
                                            <Box
                                                sx={{
                                                    width: 38,
                                                    height: 38,
                                                    borderRadius: 2,
                                                    display: "grid",
                                                    placeItems: "center",
                                                    background: isMod ? "rgba(59,130,246,0.14)" : "rgba(16,185,129,0.14)",
                                                    border: "1px solid rgba(255,255,255,0.10)",
                                                    color: "rgba(255,255,255,0.92)",
                                                    flex: "0 0 auto",
                                                    mt: 0.1,
                                                }}
                                            >
                                                {c.icon}
                                            </Box>

                                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                                    <Typography sx={{ color: "#fff", fontWeight: 900, lineHeight: 1.2 }}>
                                                        {c.title}
                                                    </Typography>

                                                    <Chip
                                                        label={c.access}
                                                        size="small"
                                                        sx={{
                                                            background: isMod ? "rgba(30,64,175,0.30)" : "rgba(5,150,105,0.22)",
                                                            color: "rgba(255,255,255,0.90)",
                                                            fontWeight: 900,
                                                            border: "1px solid rgba(255,255,255,0.12)",
                                                            flex: "0 0 auto",
                                                        }}
                                                    />
                                                </Box>

                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: "rgba(255,255,255,0.72)",
                                                        mt: 0.6,
                                                        lineHeight: 1.35,
                                                    }}
                                                >
                                                    {c.description}
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        mt: 1.1,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: 1,
                                                        flexWrap: { xs: "wrap", sm: "nowrap" },
                                                    }}
                                                >
                                                    <Box sx={{ minWidth: 0 }}>
                                                        <Typography
                                                            sx={{
                                                                color: "rgba(255,255,255,0.92)",
                                                                fontWeight: 900,
                                                                fontSize: 13,
                                                                fontFamily:
                                                                    "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}
                                                            title={c.command}
                                                        >
                                                            {c.command}
                                                        </Typography>

                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                display: "block",
                                                                color: "rgba(255,255,255,0.58)",
                                                                mt: 0.2,
                                                                fontFamily:
                                                                    "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}
                                                            title={c.usage}
                                                        >
                                                            приклад: {c.usage}
                                                        </Typography>
                                                    </Box>

                                                    <Button
                                                        variant="outlined"
                                                        onClick={() => copyCommand(c.command)}
                                                        startIcon={<ContentCopyIcon fontSize="small" />}
                                                        sx={{
                                                            borderRadius: 999,
                                                            textTransform: "none",
                                                            fontWeight: 900,
                                                            px: 1.6,
                                                            py: 0.7,
                                                            color: "rgba(255,255,255,0.92)",

                                                            borderColor: isMod ? "rgba(59,130,246,0.35)" : "rgba(16,185,129,0.35)",
                                                            background: isMod ? "rgba(59,130,246,0.10)" : "rgba(16,185,129,0.10)",

                                                            "&:hover": {
                                                                borderColor: isMod ? "rgba(59,130,246,0.55)" : "rgba(16,185,129,0.55)",
                                                                background: isMod ? "rgba(59,130,246,0.16)" : "rgba(16,185,129,0.16)",
                                                                transform: "translateY(-1px)",
                                                            },
                                                            transition: "all 160ms ease",
                                                            whiteSpace: "nowrap",
                                                            flex: "0 0 auto",
                                                        }}
                                                    >
                                                        Copy
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Paper>
                                );
                            })}
                        </Stack>
                    </Paper>
                </Box>
            </Box>
        </Box>
    );
};

export default Shizobali;
